// components/sections/ContactInformation.tsx
import React from 'react';
import { Registry } from '@/graphql/__generated__/onboarding-legal';
import TextSection from './TextSection';

interface ContactInformationProps {
	registry: Registry;
}

export const ContactInformation: React.FC<ContactInformationProps> = ({ registry }) => {
	return (
		<div className="space-y-3">
			<TextSection
				label="Email"
				value={registry.email}
				field="Email"
				sectionName="ContactInformation"
			/>
			<TextSection
				label="PhoneNumber"
				value={registry.phoneNumber}
				field="PhoneNumber"
				sectionName="ContactInformation"
			/>
		</div>
	);
};

export default ContactInformation;
